 /* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
 import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
/* eslint-disable arrow-body-style */
import { StorageService } from './storage.service';
import { MessageService } from 'src/app/services/message.service';
import { cartItem } from 'src/app/models/cart.model';
import { articoloBE, clienteBE } from './../models/sync.model';
/* eslint-disable @typescript-eslint/no-shadow */
import { cart, order, ordineDaTrasmettere } from './../models/cart.model';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { Storage } from '@capacitor/storage';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import * as uuid from 'uuid';
import { db } from '../db';
@Injectable({
  providedIn: 'root'
})
export class CartService {
  public $cart = new Subject<cart>();
  public $ordersToSend = new Subject<number>();
  public cart: cart;
  constructor(private messageservice: MessageService, private storage: StorageService, private userservice: UserService) {
    this.cart = new cart();
  }

  async mostraPreferiti() {
    return this.storage.get('favoriti').then((favoriti: Array<any>) => {
      return favoriti;
    });
  }

  async getBookInfo(cliente: clienteBE, book: articoloBE) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const search = (cliente) ? {cod_cliente : cliente.conto, ean : book.ean} :  {ean : book.ean};
    return this.storage.get('contodeposito').then((c:  Array<any> )=> {
      const syncData: Array<any>  = c;
      const contoDepositoCliente = _.filter(syncData,search);
      let qta = 0;
      contoDepositoCliente.forEach((libroConto) => {

        qta+= Number(libroConto.qta);
      });
       const quantitaContoDeposito = qta;
      return db.getPrenotazioni().then((c: Array<any>) => {
        const syncData: Array<any>  = c;
        const prenotazioni = _.filter(syncData, search);
        let qtaPrenotazione = 0;
        prenotazioni.forEach((libroConto) => {
             qtaPrenotazione+= Number(libroConto.rimanenza);
        });
        return db.getOrdini().then((ordini) => {
          const  o: Array<any> = ordini;
          const ordiniclienteprodotto = _.filter(o, search);
           let qtaOrdine = 0;
          ordiniclienteprodotto.forEach((ordine) => {
            qtaOrdine+= (Number(ordine.rimanenza) + Number(ordine.qta_in_spedizione));
          });
        //  console.log('fine', this.qtaContoDeposito);
            return {ordineQta : qtaOrdine, prenotazione : qtaPrenotazione, contoDeposito : qta};

        });
      });
    });
  }


  async togglePreferito(book: articoloBE) {
    return this.storage.get('favoriti').then((favoriti: Array<any>) => {
      if (favoriti) {
        const o = _.find(favoriti, { ean: book.ean });
        if (!o) {
          favoriti.push(book);
          this.storage.set('favoriti', favoriti);
          return true;
        } else {
          const index = _.findIndex(favoriti, { ean: book.ean });
          favoriti.splice(index, 1);
          this.storage.set('favoriti', favoriti);
          return false;
        }
      } else {
        const fav: Array<any> = [];
        fav.push(book);
        this.storage.set('favoriti', fav);
        return true;
      }
    });
  }

  async isFavourite(codiceEan: string) {
    return this.storage.get('favoriti').then((favoriti: Array<any>) => {
      const index = _.find(favoriti, { ean: codiceEan });
      if (index) {
        return true;
      }
      return false;
    });

  }

  /**
   * loadCarts
   *
   * @returns Promise<Array<Rapporto>>
   */
  public async loadCarts(): Promise<Array<cart>> {
    const { value } = await Storage.get({ key: 'carts' });
    if (value) {
      const carts = JSON.parse(value);
      return carts;
    }
    return null;
  }

  public listenCart(): Observable<cart> {
    return this.$cart.asObservable();
  }

  public listenOrdersToSend(): Observable<number> {
    return this.$ordersToSend.asObservable();
  }

  public setOrdersToSend(orders: number): void {
    this.$ordersToSend.next(orders);
  }



  /**
   * Salva un tutti i carts nello storage;
   *
   * @param carts
   */
  public async saveCarts(carts) {
    //await Storage.remove({ key: 'reports' });
    await Storage.set({
      key: 'carts',
      value: JSON.stringify(carts),
    });
  }




  /**
   * Carica il carrello del cliente dallo storage
   *
   * @param cliente id
   * @returns Promise<Rapporto>
   */
  public async loadCart(id: string): Promise<cart | null> {
    return this.loadCarts().then((data: Array<cart>) => {
      const index = _.findIndex(data, { cliente: id, closed: false });
      this.$cart.next(((index > -1) ? data[index] : null));
      return (index > -1) ? data[index] : null;
    });
  }


  /**
   * saveCart
   *
   * @param cart
   * @returns
   */
  public async saveCart(cart: cart) {
    if (cart && cart.cliente) {
    return this.loadCarts().then((data: Array<cart>) => {
      const carts = (data) ? data : [];
      if (carts.length > 0) {
        const alreadyExist = _.findIndex(carts, { cliente : cart.cliente, closed: false});
        if (alreadyExist > -1) {
          carts.splice(alreadyExist, 1);
        }
      }
      this.$cart.next(cart);
      carts.push(cart);
      return this.saveCarts(carts).then(() => 'ok');
    });
  }
  }

 public async loadToSendOrders() {
    const { value } = await Storage.get({ key: 'to-send' });
    if (value) {
      const carts = JSON.parse(value);
      return carts;
    }
    return null;
  }

  public async loadToSendOrder(id: string): Promise<ordineDaTrasmettere|null> {
      return this.loadToSendOrders().then(ordini => {
          const i =  _.findIndex(ordini, {id: id});
          return (i > -1) ? ordini[i] : null;
      });
  }

  public async saveToSendOrders(orders: Array<ordineDaTrasmettere>) {
    await Storage.set({
      key: 'to-send',
      value: JSON.stringify(orders),
    });
  }


  /**
   * carica tutti gli ordini trasmessi
   * @returns
   */
  public async loadSendedOrders() {
    const { value } = await Storage.get({ key: 'sended' });
    if (value) {
      const carts = JSON.parse(value);
      return carts;
    }
    return null;
  }

  /** carica orders in ordini trasmessi */
  public async saveSendedOrders(orders: Array<ordineDaTrasmettere>) {
    await Storage.set({
      key: 'sended',
      value: JSON.stringify(orders),
    });
  }


  /** salva un singolo ordine da trasmettere in ordini trasmessi */
  public async saveSendedOrder(order: ordineDaTrasmettere) {
      if (order.dataTrasmissione) {
        return this.loadSendedOrders().then((data: Array<ordineDaTrasmettere>) => {
          const orders = (data) ? data : [];
          orders.push(order);
          return this.saveSendedOrders(orders);
        });
      }
      return null;

  }



  /**
   * eliminaOrder
   * @param order
   */
  public eliminaOrder(order: ordineDaTrasmettere) {
      return this.loadToSendOrders().then(orders => {
        const index = _.findIndex(orders, { id: order.id });
        orders.splice(index, 1);

        return this.saveToSendOrders(orders).then(() => {
          this.messageservice.setEvent({ type: 'reload' });
        });
      });

  }


  /**
   * Ripristina l'ordine del cliente da trasmettere
   * @param order
   * @returns
   */
 async ripristinaOrder(order: ordineDaTrasmettere): Promise<boolean> {
    return this.loadCarts().then((data: Array<cart>) => {
      const carts = (data) ? data : [];
      order.cart.righe = order.cart.righe.filter((riga: cartItem) => {
          return _.findIndex(order.datiRord.elencoArticoli, {ean : Number(riga.ean)}) > -1;
      });
      const carrello = new cart(order.cart.righe);
      Object.assign(carrello, order.cart);
      return this.saveCart(carrello).then(() => {
        this.messageservice.setEvent({ type: 'reload' });
        return true;
      });

    });

  }

  /**
   * saveOrder genera gli ordini dal carrelo
   *
   * @param cart
   * @returns
   */
  public async saveOrder(cart: cart) {
    /*
    *    "O"   Ordine  <default>
    *    "CD"  Conto Deposito
    *    "P"   Prenotazione
    *    "PCD" Prenotazione Conto Deposito
    */
    const CD: Array<cartItem> = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato !== 'I' && o.contoDeposito) {
        return o;
      }
    });
    const P: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato === 'I' && !o.contoDeposito) {
        return o;
      }
    });
    const PCD: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato === 'I' && o.contoDeposito) {
        return o;
      }
    });
    const O: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato !== 'I' && !o.contoDeposito) {
        return o;
      }
    });
    const agente: User = this.userservice.getUser();

    cart.id = uuid.v4();
    const orders: Array<ordineDaTrasmettere> = [];
    if (CD.length) {
      // salvo un nuovo ordine da trasmettere
      const cd: order =  new order(cart, CD, 'CD', agente);
      const tot: number = _.sumBy(cd.datiRord.elencoArticoli, 'qta');
      const om  = _.sumBy(cd.datiRord.elencoArticoli, function(o) { return (o.omaggio==='S') ? o.qta : 0;});
      orders.push({
        datiRord: cd.datiRord ,
        cart: cart,
        totale : tot,
        omaggi: om,
        id: uuid.v4()
       });
      }
   if (P.length) {
       // orders.push(new order(cart, P, 'P', agente));
       const p: order =  new order(cart, P, 'P', agente);
       const tot: number = _.sumBy(p.datiRord.elencoArticoli, 'qta');
       const om  = _.sumBy(p.datiRord.elencoArticoli, function(o) { return (o.omaggio==='S') ? o.qta : 0;});
       orders.push({
         datiRord: p.datiRord ,
         cart: cart,
         totale : tot,
         omaggi: om,
         id: uuid.v4()
        });
    }
    if (PCD.length) {
      //  orders.push(new order(cart, PCD, 'PCD', agente));
       const pcd: order =  new order(cart, PCD, 'PCD', agente);
       const tot: number = _.sumBy(pcd.datiRord.elencoArticoli, 'qta');
       const om  = _.sumBy(pcd.datiRord.elencoArticoli, function(o) { return (o.omaggio==='S') ? o.qta : 0;});
       orders.push({
         datiRord: pcd.datiRord ,
         cart: cart,
         totale : tot,
         omaggi: om,
         id: uuid.v4()
        });
    }
    if (O.length) {
       // orders.push(new order(cart, O, 'O', agente));
       const ord: order =  new order(cart, O, 'O', agente);
       const tot: number = _.sumBy(ord.datiRord.elencoArticoli, 'qta');
       const om  = _.sumBy(ord.datiRord.elencoArticoli, function(o) { return (o.omaggio==='S') ? o.qta : 0;});
       orders.push({
         datiRord: ord.datiRord ,
         cart: cart,
         totale : tot,
         omaggi: om,
         id: uuid.v4()
        });
        console.log('ordini salvati',orders);
    }
    return this.loadToSendOrders().then((storedOrders: Array<ordineDaTrasmettere>)  =>{
        const toStore = (storedOrders) ? storedOrders : [];

        orders.forEach(ordine => {
          toStore.push(ordine);
        });
        return this.saveToSendOrders(toStore).then(() => {
          return this.loadCarts().then((data) => {
            const carts = (data) ? data : [];
              const index = _.findIndex(carts, { cliente: cart.cliente });
              if (index > -1) {
                carts.splice(index, 1);
              }
              return this.saveCarts(carts).then(() => {
                this.messageservice.setEvent({ type: 'reload' });
              });
            });
        });
    });
    }

  public loadOrdersPayload(cart: cart): Array<order> {
    /*
    *    "O"   Ordine  <default>
    *    "CD"  Conto Deposito
    *    "P"   Prenotazione
    *    "PCD" Prenotazione Conto Deposito
    */
   const orders = [];
    const CD: Array<cartItem> = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato !== 'I' && o.contoDeposito) {
        return o;
      }
    });
    const P: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato === 'I' && !o.contoDeposito) {
         return o;
      }
    });
    const PCD: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato === 'I' && o.contoDeposito) {
        return o;
      }
    });
    const O: Array<cartItem>  = _.filter(cart.righe, (o: cartItem) => {
      if (o.article.stato !== 'I' && !o.contoDeposito) {
        return o;
      }
    });
    const agente: User = this.userservice.getUser();

    if (CD.length) {
       orders.push(new order(cart, CD, 'CD', agente))  ;
    }
    if (P.length) {
       orders.push(new order(cart, P, 'P', agente)) ;
    }
    if (PCD.length) {
      orders.push(new order(cart, PCD, 'PCD', agente));
    }
    if (O.length) {
      orders.push(new order(cart, O, 'O', agente));
    }
    return orders;
  }

}
